export default __webpack_public_path__ + "static/cashflow5-8a2637cb52a341a2970bad1f9412d5de.jpg";